export default "__VITE_ASSET__DSz$mzYc__"